import { IIcon } from "@geotab/zenith";
import React from "react";

interface IMenuItemProps {
    id: string;
    link: string;
    title: string;
    icon: React.FC<IIcon>;
    hasIndicator?: boolean;
    isActive?: boolean;
    onClick: (link: string) => void;
}

const MenuItem: React.FC<IMenuItemProps> = ({
    id,
    link,
    title,
    hasIndicator,
    isActive,
    onClick,
    // eslint-disable-next-line @typescript-eslint/naming-convention
    icon: Icon
}: IMenuItemProps) => {
    const handleKeyDown = (event: React.KeyboardEvent<HTMLLIElement>) => {
        if (event.code === "Enter" || event.code === "Space") {
            event.preventDefault();
            onClick(link);
        }
    };

    return (
        <li className={`tab tabbar__tab footer-link ${ isActive ? "active" : "" }`} aria-selected={ isActive ? "true" : "false" } id={id} data-id={link} role="menuitem" aria-controls="content" tabIndex={0} onClick={() => onClick(link)} onKeyDown={handleKeyDown}>
            <a className="invisible-link" href={`#${ link }`}>
                <span className="notification-container">
                    <Icon size="huger" />
                    {hasIndicator && <span className="notification-circle"></span>}
                </span>
                <span className="footer-link-title">{title}</span>
                <span className="active-state"></span>
            </a>
        </li>
    );
};

export default MenuItem;